

































import { Component, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import SidebarImageUpload from '@/components/Media/SidebarImageUpload.vue';

@Component({
    components: {
        SidebarImageUpload,
    },
})
export default class UploadFloorPlan extends Vue {
    constructor() {
        super();
    }

    get activeVariantId(): any {
        return this.$store.getters['Variants/getVariantId'];
    }

    get getFloorPlan() {
        return this.$store.getters['User/getFloorPlanBase64'];
    }

    get loadFloorPlan() {
        return this.getFloorPlan !== '';
    }

    get newFloorPlanSelected() {
        return this.$store.getters['Variants/getNewFloorPlanSelected'];
    }

    get disabledButton() {
        return {
            'hococo-inactive-button': (!this.newFloorPlanSelected),
        };
    }

    public slideOutFormCancel() {
        this.$store.commit(Mutations.HIDE_UPLOAD_FLOOR_PLAN_FORM);
    }

    public slideOutFormCreate() {
        this.$store.dispatch(Actions.UPLOAD_FLOOR_PLAN);
        this.$store.commit(Mutations.HIDE_UPLOAD_FLOOR_PLAN_FORM);
    }
}
